import React from "react";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";

/**
 * Renders CODE128 barcode from value stored in DB (image generated client-side only).
 */
const BarcodeDisplay = ({
	value,
	format = "CODE128",
	width = 1.5,
	height = 48,
	displayValue = true,
	className = "",
	showPlaceholder = true,
}) => {
	const { t } = useTranslation();
	const trimmed = String(value || "").trim();

	if (!trimmed) {
		if (!showPlaceholder) return null;
		return (
			<span className={`text-muted small ${className}`.trim()}>
				{t("No barcode assigned")}
			</span>
		);
	}

	return (
		<div className={`barcode-display ${className}`.trim()}>
			<Barcode
				value={trimmed}
				format={format}
				width={width}
				height={height}
				displayValue={displayValue}
				margin={4}
			/>
		</div>
	);
};

export default BarcodeDisplay;
